export default "__VITE_ASSET__3e805128__"